import { createReducer, on } from '@ngrx/store';
import { GatewayFirmwareUpdateStatus } from '@vi-iot/client/index';
import { GatewayFirmwareUpdateActions } from './gateway-firmware-update.actions';
import { GatewayFirmwareUpdateState } from './gateway-firmware-update.state';

export const initGatewayFirmwareUpdateState: GatewayFirmwareUpdateState = {
  loading: false,
  loaded: false,
  error: null,
  status: GatewayFirmwareUpdateStatus.IDLE,
};

export const gatewayFirmwareUpdateReducer = createReducer(
  initGatewayFirmwareUpdateState,

  on(
    GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessStart,
    (state): GatewayFirmwareUpdateState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
      status: GatewayFirmwareUpdateStatus.DOWNLOADING,
    })
  ),

  on(
    GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessSuccess,
    (state): GatewayFirmwareUpdateState => ({
      ...state,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(
    GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessError,
    (state, { err }): GatewayFirmwareUpdateState => ({
      ...state,
      loading: false,
      loaded: false,
      error: err,
    })
  ),

  on(
    GatewayFirmwareUpdateActions.setStatus,
    (state, { updatedStatus }): GatewayFirmwareUpdateState => ({
      ...state,
      status: updatedStatus,
    })
  )
);
